import React, {Component} from 'react';
import BackEnd from '../../../../backend/BackEnd';
import {successToast} from "../../../../utils/toasts";

const $ = window.jQuery;

class TenderBase extends Component {
    async sendToArchive() {
        const {onUpdate} = this.props;
        const {tenderId, tenderNumber} = this.props.data;

        const archive = new BackEnd.TenderOperator.Archive(this);
        const result = await archive.call({tenderId});
        if (result.success) {
            successToast(`Тендер №${tenderNumber} успешно отправлен в архив`);
            if (onUpdate) onUpdate();
            $(document).trigger('fetchCounters');
        }
    }

    editNote() {
        this.setState({
            editNote: true,
            noteTemp: this.state.note
        })
    }

    async updateNote() {
        const {tenderId} = this.props.data;

        let note = this.state.noteTemp;

        this.setState({editNote: false, note});

        let updateNote = new BackEnd.TenderOperator.UpdateComment();
        let result = await updateNote.call({tenderId, comment: note});

        if (result.success) {

        }
    }

    async updateTypeId(typeId) {
        const {tenderId} = this.props.data;

        this.setState({typeId});

        let updateTypeId = new BackEnd.TenderOperator.UpdateTypeId(this);
        let result = await updateTypeId.call({tenderId, typeId});

        if (result.success) {

        }
    }

    async updateOrderNumber(orderNumber) {
        const {tenderId} = this.props.data;

        this.setState({orderNumber});

        let updateOrderNumber = new BackEnd.TenderOperator.UpdateOrderNumber();
        let result = await updateOrderNumber.call({tenderId, orderNumber});

        if (result.success) {

        }
    }

    async updatePurchaseOrderNumber(purchaseOrderNumber) {
        const {tenderId} = this.props.data;

        this.setState({purchaseOrderNumber});

        let updatePurchaseOrderNumber = new BackEnd.TenderOperator.UpdatePurchaseOrderNumber();
        let result = await updatePurchaseOrderNumber.call({tenderId, purchaseOrderNumber});

        if (result.success) {

        }
    }

    async updateDeliveryTypeId(deliveryTypeId) {
        const {tenderId} = this.props.data;

        this.setState({deliveryTypeId});

        let updateDeliveryType = new BackEnd.TenderOperator.UpdateDeliveryType();
        let result = await updateDeliveryType.call({tenderId, deliveryTypeId});

        if (result.success) {

        }
    }

    async updatePayerId(payerId) {
        const {tenderId} = this.props.data;

        this.setState({payerId});

        let updatePayer = new BackEnd.TenderOperator.UpdatePayer();
        let result = await updatePayer.call({tenderId, payerId});

        if (result.success) {

        }
    }

    async updatePaymentConditionsId(paymentConditionsId) {
        const {tenderId} = this.props.data;

        this.setState({paymentConditionsId});

        let updatePaymentConditions = new BackEnd.TenderOperator.UpdatePaymentConditions();
        let result = await updatePaymentConditions.call({tenderId, paymentConditionsId});

        if (result.success) {

        }
    }

    getRelativeTenderUrl() {
        return `/tenders/${this.props.data.tenderId}`;
    }

    getAbsoluteTenderUrl() {
        return `${window.location.origin}${this.getRelativeTenderUrl()}`;
    }
}

export default TenderBase;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/components/TenderBase.js